import extractErrorMessage from '../utils/extractErrorMessage';
import { authClient } from './client';

export const fetchVips = async ({
  page = 1,
  limit = 10,
  filter = null,
  search = null,
}) => {
  try {
    let query = `?page=${page}&limit=${limit}&vipStatus=active`;

    // Object.entries(filter).forEach(([key, value]) => {
    //   if (!value || value === 'all') return;

    //   if (Array.isArray(value)) {
    //     query += `&${key}=${value.map((v) => encodeURIComponent(v)).join(',')}`;
    //   } else {
    //     query += `&${key}=${encodeURIComponent(value)}`;
    //   }
    // });

    if (search) {
      query += `&search=${search}`;
    }
    console.log('Fetching users with query:', query);
    // return;

    const response = await authClient.get(`/users${query}`);
    console.log('Fetched vips response:', response.data);

    return response.data;
    // return {
    //   data: {
    //     users: response.data.users,
    //     page: response.data.page,
    //     totalPages: response.data.totalPages,
    //   },
    //   error: null,
    // };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const fetchVipDetails = async (id) => {
  try {
    const response = await authClient.get(`/users/${id}/vip-profile`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju detalja o VIP-u.'
    );
    return { data: null, success: false, message: message };
  }
};

export const grantVip = async (userId, validUntil) => {
  try {
    const response = await authClient.post(`/users/${userId}/vip-grant`, {
      validUntil,
    });
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dodeli VIP članstva.'
    );
    return { data: null, success: false, message: message };
  }
};

export const extendVip = async (userId, validUntil) => {
  try {
    const response = await authClient.put(`/users/${userId}/vip-extend`, {
      validUntil,
    });
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri produženju VIP članstva.'
    );
    return { data: null, success: false, message: message };
  }
};
